import { Fragment, useCallback } from 'react';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { RequiredPermissions } from './RequiredPermissions';
import { PlanCompatibility } from './PlanCompatibility';
import { getFormattedUrl } from '../../../common/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Section = ({
  children,
  label
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx("dt", {
    children: label
  }), /*#__PURE__*/_jsx("dd", {
    children: children
  })]
});
export const Requirements = ({
  appContext,
  appName,
  companyName,
  connectionType,
  homemade,
  iconUrl,
  installability,
  features,
  integrationFeatures,
  isOpsHubListing,
  neededScopeGroups,
  onOpenFeatureCompatibilityModal,
  onTrackInteraction,
  pricingUrl: appPricingUrl,
  pricings,
  scrollToTabSection,
  tabIds,
  tiers
}) => {
  const trackInteraction = useCallback((action, value) => onTrackInteraction(action, {
    section: 'requirements',
    value
  }), [onTrackInteraction]);
  const renderedAppPricingPlans = /*#__PURE__*/_jsx(Link, {
    external: !!appPricingUrl,
    href: appPricingUrl ? getFormattedUrl(appPricingUrl) : undefined,
    onClick: () => {
      trackInteraction('click app pricing link');
      if (!appPricingUrl) {
        scrollToTabSection(tabIds === null || tabIds === void 0 ? void 0 : tabIds.PRICING);
      }
    },
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "marketplace-ui-apps-core.detail.sidebar.requirements.pricingPlans",
      options: {
        count: pricings.length,
        plans: /*#__PURE__*/_jsx(FormattedList, {
          exclusive: true,
          children: pricings.map((pricing, index) => /*#__PURE__*/_jsx("span", {
            children: pricing.name
          }, `pricing-${index}`))
        })
      }
    })
  });
  return /*#__PURE__*/_jsxs(DescriptionList, {
    "data-test-id": "requirements-section",
    children: [!!tiers.length && /*#__PURE__*/_jsx(Section, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.compatibilityHeadingText"
      }),
      children: /*#__PURE__*/_jsx(PlanCompatibility, {
        appContext: appContext,
        features: features,
        integrationFeatures: integrationFeatures,
        installability: installability,
        isOpsHubListing: isOpsHubListing,
        onOpenFeatureCompatibilityModal: onOpenFeatureCompatibilityModal,
        tiers: tiers,
        trackInteraction: trackInteraction
      })
    }), /*#__PURE__*/_jsx(Section, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.headingText"
      }),
      children: /*#__PURE__*/_jsx(RequiredPermissions, {
        appName: appName,
        connectionType: connectionType,
        homemade: homemade,
        iconUrl: iconUrl,
        neededScopeGroups: neededScopeGroups,
        trackInteraction: trackInteraction
      })
    }), !!pricings.length && /*#__PURE__*/_jsx(Section, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.pricingPlansHeadingText",
        options: {
          name: homemade ? appName : companyName
        }
      }),
      children: renderedAppPricingPlans
    })]
  });
};